import ChartSettingsModal from 'views/storyboard/chart_settings/ChartSettingsModal';

export default ChartSettingsModal;
